import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TransferStateService } from '@scullyio/ng-lib';

@Injectable({
  providedIn: 'root'
})
export class InfoResolver implements Resolve<any> {
  constructor(private http: HttpClient,
    private transferStateService: TransferStateService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const lang = route.url[0].path;

    // URL for the main JSON file and metadata file
    const mainDataUrl = `../../../assets/${environment.projectName}/pages-components.json`;
    const metadataUrl = `../../../assets/${environment.projectName}/content/${lang}/info-page/meta-data.json`;

    // Fetch main data and metadata in parallel
    return forkJoin({
      mainData: this.transferStateService.useScullyTransferState('mainData', this.http.get<any>(mainDataUrl).pipe(catchError(() => of(null)))),
      metadata: this.transferStateService.useScullyTransferState('metaData', this.http.get<any>(metadataUrl).pipe(catchError(() => of(null))))
    }).pipe(
      switchMap(({ mainData, metadata }) => {
        const infoComponents = mainData?.infoComponents || [];

        if (infoComponents.length > 0) {
          // For each component in infoComponents, fetch the corresponding JSON file
          const componentWithDetailsRequests = infoComponents.map((item: any) => {
            const fileName = item.fileName;
            const subJsonPath = `../../../assets/${environment.projectName}/content/${lang}/${fileName}.json`;

            return this.transferStateService.useScullyTransferState('subJson', this.http.get(subJsonPath).pipe(
              map((details) => ({ ...item, details })), // Add fetched details to each item
              catchError((error) => {
                console.error(`Failed to fetch ${fileName}:`, error);
                return of({ ...item, details: null });
              }))
            );
          });

          // Combine infoComponents details with metadata
          return forkJoin(componentWithDetailsRequests).pipe(
            map((componentsWithDetails) => ({
              ...mainData,
              infoComponents: componentsWithDetails,
              metadata
            }))
          );
        } else {
          console.warn("No components found in infoComponents.");
          return of({ ...mainData, metadata });
        }
      }),
      catchError((error) => {
        console.error('Error fetching data:', error);
        return of(null);
      })
    );
  }
}
